<aza-rws-profile-header titleTranslationKey="MY_PROFILE" (closed)="onClosed()"></aza-rws-profile-header>
@if (response) {
  <div class="profile-profile-page">
    @for (section of fieldsSections; track section; let i = $index) {
      <div class="profile-page-section">
        <div class="">{{section.section.label}}</div>
        <div class="section-fields-container section-form-single-column aza-section aza-theme aza-form"
          [class.sectiontype-1]="section.twoColumns">
          <div class="aza-section-content aza-section-colors">
            <div class="aza-form-field-area" id="{{'profile-page-aza-form-field-area-section-index-' + i}}">
            </div>
          </div>
        </div>
      </div>
    }
    <!-- <section *ngFor="let evt of profileEvents" class="aza-section aza-theme">
    <div class="aza-section-content profile-event">
      <div class="profile-event-name">{{evt.name}}</div>
      <div class="profile-event-start">{{evt.start}}</div>
      <div class="profile-event-end">{{evt.start}}</div>
      <div class="profile-event-timezone">{{evt.timezone}}</div>
      <div class="profile-event-description">{{evt.description}}</div>
    </div>
    <section class="section-divider aza-section aza-theme">
      <div class="aza-section-content"></div>
    </section>
  </section> -->
  <section
    class="section-form-button aza-section aza-theme profile-change-password-confirm-container profile-control-actions-container">
    <div class="aza-section-content aza-section-colors">
      <button (click)="onConfirm()"
        class="aza-button aza-section-inverted-colors profile-change-password-confirm-button"
      translate>CONFIRM</button>
    </div>
  </section>
</div>
}